import React from 'react';
import * as s from './styled-button';

const Button = ({
  label,
  onClick,
  color,
  background,
  width,
  height,
  disabled,
  hover,
  animate,
  maxWidth,
  type = 'button',
}) => {
  return (
    <s.Button
      type={type}
      disabled={disabled}
      width={width}
      height={height}
      color={color}
      background={background}
      onClick={onClick}
      hover={hover}
      animate={animate}
      maxWidth={maxWidth}
    >
      {label}
    </s.Button>
  );
};

export default Button;
